import React, { useEffect, useState } from 'react';
import { UserActionLog } from '@go-client/components/UserRecords/UserActionLog';
import { FieldsReplacer } from '@go-client/components/UserRecords/Visualizations/utils';
import { useServerInfo } from '@go-client/context/ServerInfoContext';
import { LogLoader } from '@go-client/components/UserRecords/LogLoader';
import { getProperty } from '@go-client/lib/api/property';

export const EventTemplateLog: React.FC<UserActionLog> = ({ body }) => {
  const { brand } = useServerInfo();
  const [logFields, setLogFields] = useState(body);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);

        let fields = {};
        if (body.brand) {
          const brandFields = FieldsReplacer(brand, body, [
            {
              from: 'name',
              to: 'brand',
            },
            {
              from: 'attributes',
              to: 'attributes',
            },
            {
              from: 'levels',
              to: 'levels',
            },
            {
              from: 'segments',
              to: 'segment',
            },
          ]);

          fields = { ...fields, ...brandFields };
        }

        if (body.source) {
          const property = await getProperty(body.source);
          const propertyFields = FieldsReplacer(property, logFields, [
            {
              from: 'name',
              to: 'source',
            },
          ]);

          fields = { ...fields, ...propertyFields };
        }

        if (body.properties) {
          let arrayOfProperties = [];
          for (let prop of body.properties) {
            const propertyDB = await getProperty(prop.property);
            const propertyFields = FieldsReplacer(propertyDB, prop, [
              {
                from: 'name',
                to: 'property',
              },
            ]);

            const { property, ...rest } = prop;
            arrayOfProperties.push({
              ...rest,
              ...propertyFields,
            });
          }

          if (arrayOfProperties.length) {
            fields = { ...fields, properties: arrayOfProperties };
          }
        }

        setLogFields({ ...logFields, ...fields });
      } catch (error) {
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [body]);

  return (
    <>
      <LogLoader isError={isError} isLoading={isLoading} fields={logFields} />
    </>
  );
};
